import { useGetSeguros } from '../query';

// Components
import { TextCustom } from '../../../atoms';
import { CardProximamente } from './card-proximamente.component';

// Utils
import { renderImagen, renderNombre } from '../../../../core/utils';

export function CardSegurosWeb({ handleClick }) {
  const { data, isLoading } = useGetSeguros();
  const whiteLabel = process.env.REACT_APP_WHITE_LABEL;

  const segurosActivos = Array.isArray(data?.data)
    ? data.data.filter(seguro => seguro.activo && seguro.whitelabel === whiteLabel)
    : [];

  return (
    <div className="hidden justify-center my-5 gap-4 lg:my-0 lg:grid lg:grid-cols-2 max-w-[100vw] xl:my-0 xl:grid xl:grid-cols-2 ">
      {!isLoading &&
        segurosActivos?.map(seguro => (
          <div className="flex flex-col items-center" key={seguro.codigo}>
            <div
              className="bg-card2 card-seguros-home flex justify-center items-center px-0 py-0 cursor-pointer hover:scale-105 transition-all duration-300 w-[75px] h-[75px] md:w-[85px] md:h-[85px] max-[]: lg:grid lg:grid-cols-2 lg:w-full lg:h-[125px] lg:px-6 lg:py-1 xl:grid xl:grid-cols-2 xl:w-[300px] xl:h-[125px] xl:px-9 xl:py-5"
              onClick={() => handleClick(seguro.codigo, seguro)}
            >
              <div>
                <TextCustom
                  text={
                    seguro.nombre.includes('Seguro de ')
                      ? 'Seguro de'
                      : 'Seguro'
                  }
                  className="hidden text-xs fontPRegular color-primary lg:block"
                  component="p"
                  variant="p"
                />
                <TextCustom
                  text={renderNombre(seguro.nombre)}
                  className="hidden fontPSemiBold color-primary lg:text-md xl:text-xl text-nombre-seguro lg:block"
                  component="p"
                  variant="p"
                />
              </div>
              <div className="flex justify-center items-center lg:justify-end lg:items-center min-h-full">
                {renderImagen[seguro.codigo]}
              </div>
            </div>
          </div>
        ))}
      <CardProximamente />
    </div>
  );
}
